<template>
    <a href="#" title="Invalider ce point" @click="unsolveItem()">
        <i class="far fa-fw fa-check-square text-secondary"></i>
    </a>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'SolvePendingPoint',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    methods: {
        async unsolveItem() {
            const form = {}
            form.status = 'SEN'
            try {
                await axios.put(`/pendingPoints/${this.point.id}/status`, form)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
